import { Autocomplete, Chip, List, TextField } from '@mui/material'
import { ImdgCodes } from '@planning/constants'
import { useTranslate } from '@tolgee/react'
import { FC } from 'react'
import { DangerousGoodOptionListItem } from '../../pages/DeliveryOrders/Components/DangerousGoodsOptionListItem'
import { PopperWithPlacement } from './DangerousGoodsAutoComplete'

export interface ImoClassAutoCompleteProps {
  value: string[]
  onChange: (values: string[]) => void
  error?: string
  placeholder?: string
}

export const ImoClassAutoComplete: FC<ImoClassAutoCompleteProps> = ({
  value,
  onChange,
  error,
  placeholder,
}) => {
  const { t } = useTranslate()

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      fullWidth
      ListboxComponent={List}
      options={ImdgCodes}
      getOptionLabel={code => code}
      PopperComponent={PopperWithPlacement}
      slotProps={{
        popper: {
          sx: { minWidth: '16rem' },
        },
      }}
      renderOption={(props, code) => (
        <DangerousGoodOptionListItem
          code={code}
          assignedCodes={value}
          props={props}
          key={`imo-class-option-${code}`}
        />
      )}
      value={value}
      renderTags={tags => (
        <>
          {tags
            .sort((a, b) => a.localeCompare(b))
            .map(imdg => (
              <Chip
                key={`imo-class-chip-${imdg}`}
                label={imdg}
                onDelete={() => onChange(value.filter(v => v !== imdg))}
              />
            ))}
        </>
      )}
      onChange={(_, newValues) => onChange(newValues)}
      renderInput={params => (
        <TextField
          {...params}
          label={t('imoClass', 'IMO Class')}
          placeholder={
            value.length === 0
              ? (placeholder ?? t('allDgClasses', 'All DG classes (no restriction)'))
              : undefined
          }
          error={!!error}
          helperText={error ? t(error) : undefined}
        />
      )}
    />
  )
}
